import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  userProfile: any;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    await this.authenticationService.ready;
    if (this.authenticationService.isAuthenticated()) {
      if (state.url === '/') {
        return this.router.parseUrl('/dentalbridge/manage-api');
      } else {
        return true;
      }
    }
    await this.authenticationService.login(state.url);
    return false;
  }
}
